import { getIntroPathForTariff } from '~/middleware/auth'

const getPathForStep = (step, activeTariff) => {
  switch (step) {
    case 4:
      return 'Offer-Summary'
    case 3:
      return 'Offer-Questions'
    case 2:
      return 'Offer-PolicyholderData'
    default:
      return getIntroPathForTariff(activeTariff)
  }
}

const getBrokerPathForStep = (step, activeTariff) => {
  switch (step) {
    case 2:
      return 'BrokerOffer-Summary'
    default:
      return `Broker${getIntroPathForTariff(activeTariff)}`
  }
}

export default function ({ store, redirect, route }) {
  const routeMatchesBrokerOffer = /BrokerOffer.*___[de|fr|it]/
  const offerRoute = route.meta.find((m) => m.offerStep)
  const isBrokerOfferRoute = routeMatchesBrokerOffer.test(route.name)
  const { activeTariff, step } = isBrokerOfferRoute
    ? store.state.brokerOffer
    : store.state.offer

  if (offerRoute && offerRoute.offerStep > step) {
    const pathForStep = isBrokerOfferRoute
      ? getBrokerPathForStep(step, activeTariff)
      : getPathForStep(step, activeTariff)
    redirect(store.app.localePath(pathForStep))
  }
}
